import { defineMessages } from 'react-intl';

export default defineMessages({
    
    EmailValidationMessage: {
        id: 'twia.addUser.views.Must be a valid email address',
        defaultMessage: 'Must be a valid email address',
    },
    RoleValidationTitle: {
        id: 'twia.addUser.views.Please Select Role',
        defaultMessage: 'Please Select Role',
    },
    RoleValidationMessage: {
        id: 'twia.addUser.views.At least one role must be selected',
        defaultMessage: 'At least one role must be selected',
    },
    RoleButtonCloseMessage:{
        id: 'twia.addUser.views.Close',
        defaultMessage: 'Close',
    },
    // DE15379 added two different messages based on org Admin/Agency Screen
    existUserOrgAdmin:{
        id: 'twia.existUser.views.Select User to Add as an Organization Admin',
        defaultMessage: 'Select User to Add as an Organization Admin',
    },
    existUserAgencyAdmin:{
        id: 'twia.existUser.views.Select User to Add to Agency/Location',
        defaultMessage: 'Select User to Add to Agency/Location',
    },
    // Added validation messages
    PhoneValidationMessage: {
        id: 'twia.existUser.views.Value must be a valid phone number of type xxx-xxx-xxxx',
        defaultMessage: 'Value must be a valid phone number of type xxx-xxx-xxxx',
    },
    PhoneValidationRequiredMessage: {
        id: 'twia.existUser.views.This is a required field.',
        defaultMessage: 'This is a required field.',
    },
});
